<template>
<div class="dropdown pull-right">
  <button class="profile-dropdown-toggle hand-pointer" type="button" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
    <span class="pull-left p-r-10 fs-14 font-heading hidden-md-down text-white">
      {{ fullName }}
    </span>
  </button>

  <div class="dropdown-menu dropdown-menu-right" role="menu">
    <router-link v-if="!isPending"
                 :to="{ name: 'EditProfile' }"
                 class="clearfix dropdown-item">
      {{ $t("current_user.edit_profile") }}
    </router-link>

    <router-link v-if="!isPending && isCandidate"
                 :to="{ name: 'CandidateEntities' }"
                 class="clearfix dropdown-item">
      {{ $t("current_user.my_entities") }}
    </router-link>

    <router-link v-if="!isCandidate"
                 :to="{ name: 'ManagerEntities' }"
                 class="clearfix dropdown-item">
      <span class="title">{{ $t("current_user.entities_profile") }}</span>
    </router-link>

    <a href="#" @click="signOut()" class="clearfix dropdown-item">
      <span class="pull-left">{{ $t("current_user.signout") }}</span>
      <span class="pull-right"><i class="pg-power"></i></span>
    </a>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import defineAbilitiesFor from '@/config/ability'
import { userStatus } from '@/settings/users'
import { checkRoleCandidate } from '@/helpers/roles'
import { sendCandidateSignOutEvent, sendManagerSignOutEvent } from '@/helpers/at_internet/follow_candidate'

export default {
  name: 'current-user',
  mounted: function(){
    this.$store.dispatch('auth/getUser')
    .then((user) => {
      if (typeof user == 'undefined') {
        this.$router.push('/users/signin')
      } else {
        // Update ability for current user
        let ability = defineAbilitiesFor(user);
        this.$ability.update(ability.rules);
        // Set selected entities by default
        this.$store.dispatch('auth/initCurrentEntityId');
        if (user.state == userStatus.pending) {
          this.$router.replace({name: 'UpdateInformation'})
        } else if (!this.$can('read', this.$router.currentRoute.name)) {
          this.$router.replace({name: 'Dashboard'})
          this.$store.dispatch('message/enable', {type: 'danger', content: this.$i18n.t('messages.cannotAccess')})
        }
      }
    }).catch(() => {})
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser'
    }),
    fullName: function (){
      if(!this.currentUser.first_name) return '';
      return `${this.currentUser.first_name} ${this.currentUser.last_name}`;
    },
    isPending() {
      return this.currentUser.state == userStatus.pending
    },
    isCandidate(){
      return checkRoleCandidate(this.currentUser.role)
    }
  },

  methods: {
    signOut: function (){
      checkRoleCandidate(this.currentUser.role) 
        ? sendCandidateSignOutEvent() 
        : sendManagerSignOutEvent()
      this.$store.dispatch('auth/signOut')
      this.$store.commit( 'users/RESET_USER', 'candidate')
      this.$router.replace({ path: '/users/signin' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/pages/_var.scss';

.hand-pointer {
  cursor: pointer;
}

.dropdown-menu{
  width: 150px;
  padding: 10px;

  a{
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/current_user.vue